export default "__VITE_ASSET__YHhvkHwg__"